module.exports = __webpack_public_path__ + "img/appAsset-flag--CL.ee0dba6a.svg";